import { featuresData } from '@/mocks/chiguaHomeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            平台特色
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            为什么千万吃瓜群众选择吃瓜在线作为今日吃瓜第一站
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuresData.map((feat, i) => (
            <div key={i} className="bg-background-100 rounded-xl p-5 md:p-6 group hover:bg-background-200/70 transition-colors cursor-default">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${feat.icon} text-xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-2">
                {feat.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}